module.exports = __webpack_public_path__ + "static/media/accountsuspended.c6d5a7d3.svg";